import React from 'react';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import * as actionCreators from '@src/store/actions';
import OauthButton from '@src/components/oauthButton';

import { Title } from './Styled';
import classes from './styles.module.less';

const StyledTitle = styled(Title)`
	margin: 15px auto 24px;
`;

const LoginWithOther = ({ actions, isBorderTop = true, isBorderBottom, t }) => {
	function handleLoginByType(type) {
		actions.addActionsToStash([
			{
				actionMethod: 'historyReplaceCall',
				actionPayload: location.pathname,
			},
		]);
		actions.socialLoginPrepareCall({ name: type });
	}
	return (
		<>
			{isBorderTop && <Title>{t('share:auth:login:or')}</Title>}
			<div>
				<OauthButton
					className={classes.oauthBtn}
					name={t('share:auth:oauth:google')}
					type="google"
					onClick={() => handleLoginByType('google')}
				/>
				<OauthButton
					className={classes.oauthBtn}
					name={t('share:auth:oauth:facebook')}
					type="facebook"
					onClick={() => handleLoginByType('facebook')}
				/>
				<OauthButton
					className={classes.oauthBtn}
					name={t('share:auth:oauth:line')}
					type="line"
					onClick={() => handleLoginByType('line')}
				/>
			</div>
			{isBorderBottom && <StyledTitle>{t('share:auth:login:or')}</StyledTitle>}
		</>
	);
};

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators({ ...actionCreators }, dispatch),
});

export default withTranslation()(
	connect(null, mapDispatchToProps)(LoginWithOther),
);
